"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitStream = exports.BitView = void 0;
class BitView {
    constructor(buffer) {
        this.view = new Uint8Array(buffer, 0, buffer.byteLength);
    }
    getBits(offset, bits, signed = false) {
        const available = this.view.length * 8 - offset;
        if (bits > available) {
            throw new Error('Bits out of bounds');
        }
        let value = 0;
        for (let i = 0; i < bits;) {
            const remaining = bits - i;
            const bitOffset = offset & 7;
            const currentByte = this.view[offset >> 3];
            const read = Math.min(remaining, 8 - bitOffset);
            const mask = (1 << read) - 1;
            const readBits = (currentByte >> bitOffset) & mask;
            value |= readBits << i;
            offset += read;
            i += read;
        }
        if (signed) {
            if (bits !== 32 && value & (1 << (bits - 1))) {
                value |= -1 ^ ((1 << bits) - 1);
            }
            return value;
        }
        return value >>> 0;
    }
    getInt8(offset) {
        return this.getBits(offset, 8, true);
    }
    getUint8(offset) {
        return this.getBits(offset, 8, false);
    }
    getInt16(offset) {
        return this.getBits(offset, 16, true);
    }
    getUint16(offset) {
        return this.getBits(offset, 16, false);
    }
    getInt32(offset) {
        return this.getBits(offset, 32, true);
    }
    getUint32(offset) {
        return this.getBits(offset, 32, false);
    }
    getFloat32(offset) {
        BitView.scratch.setUint32(0, this.getUint32(offset));
        return BitView.scratch.getFloat32(0);
    }
    getFloat64(offset) {
        BitView.scratch.setUint32(0, this.getUint32(offset));
        BitView.scratch.setUint32(4, this.getUint32(offset + 32));
        return BitView.scratch.getFloat64(0);
    }
}
exports.BitView = BitView;
BitView.scratch = new DataView(new ArrayBuffer(8));
class BitStream {
    constructor(source) {
        this.view = new BitView(source);
        this.index = 0;
    }
    readBits(bits, signed = false) {
        const val = this.view.getBits(this.index, bits, signed);
        this.index += bits;
        return val;
    }
    readInt8() {
        const val = this.view.getInt8(this.index);
        this.index += 8;
        return val;
    }
    readUint8() {
        const val = this.view.getUint8(this.index);
        this.index += 8;
        return val;
    }
    readInt16() {
        const val = this.view.getInt16(this.index);
        this.index += 16;
        return val;
    }
    readUint16() {
        const val = this.view.getUint16(this.index);
        this.index += 16;
        return val;
    }
    readInt32() {
        const val = this.view.getInt32(this.index);
        this.index += 32;
        return val;
    }
    readUint32() {
        const val = this.view.getUint32(this.index);
        this.index += 32;
        return val;
    }
    readFloat32() {
        const val = this.view.getFloat32(this.index);
        this.index += 32;
        return val;
    }
    readFloat64() {
        const val = this.view.getFloat64(this.index);
        this.index += 64;
        return val;
    }
    readString(bytes = 0, utf8 = false) {
        let i = 0;
        const chars = [];
        let append = true;
        while (!bytes || (bytes && i < bytes)) {
            const c = this.readUint8();
            if (c === 0x00) {
                append = false;
                if (!bytes) {
                    break;
                }
            }
            if (append) {
                chars.push(c);
            }
            i++;
        }
        const string = String.fromCharCode.apply(null, chars);
        if (utf8) {
            try {
                return decodeURIComponent(string);
            }
            catch (e) {
                return string;
            }
        }
        else {
            return string;
        }
    }
}
exports.BitStream = BitStream;
